import * as React from 'react';
import { Dialog } from 'primereact/dialog';

import { ProjectDocTypeVals } from "../../../../helpers/mapping/ProjectDocTypes";
import { ProjectDocFolder } from "../../models/ProjectDocFolder";
import { NewInput } from '../../../../components/synced/ui/NewInput/NewInput';
import { NewCalendar } from '../../../../components/synced/ui/NewCalendar/NewCalendar';
import { constantFormat } from '../../../../helpers/constants';
import { DocTemplateFolderTypeVals } from '../../../../helpers/constants/modelValues/DocTemplateFolderTypeVals';
import { NewButton } from '../../../../components/synced/ui/NewButton/NewButton';


interface EditTomDialogProps {
  visible: boolean;
  folder: ProjectDocFolder;
  docTypeId: number;
  onSave: (folder: ProjectDocFolder) => void;
  onCancel: () => void;
}

export const EditTomDialog: React.FC<EditTomDialogProps> = ({ visible, folder, docTypeId, onSave, onCancel }) => {
  const [data, setData] = React.useState<ProjectDocFolder>({ ...folder });
  React.useEffect(() => setData({ ...folder }), [folder]);


  const hasCypher = React.useCallback((): boolean => {
    return docTypeId === ProjectDocTypeVals.PD ||
           docTypeId === ProjectDocTypeVals.WD ||
           docTypeId === ProjectDocTypeVals.II ||
           docTypeId === ProjectDocTypeVals.PDEdit ||
           docTypeId === ProjectDocTypeVals.WDEdit ||
           docTypeId === ProjectDocTypeVals.IIEdit ||
           docTypeId === ProjectDocTypeVals.Executive;
  }, [docTypeId]);

  const hasDocumentDate = React.useCallback((): boolean => {
    return docTypeId === ProjectDocTypeVals.Executive &&
     (data?.FolderTypeId === DocTemplateFolderTypeVals.Act || data?.FolderTypeId === DocTemplateFolderTypeVals.ActDocument);
  }, [docTypeId, data]);

  const isDataValid = React.useCallback((): boolean => {
    if (!Boolean(data.Title))
      return false;

    if (hasCypher() && !Boolean(data.Cypher))
      return false;

    if (hasDocumentDate() && !Boolean(data.DocumentDate))
      return false;

    return true;
  }, [data, docTypeId, hasCypher, hasDocumentDate]);


  const footer = (
    <div className="pd-dialog-footer">
      <NewButton variant="secondary" icon="fa-solid fa-xmark" onClick={onCancel}>Отменить</NewButton>
      <NewButton variant="primary" icon="fa-solid fa-check" disabled={!isDataValid()} onClick={() => { data.Children = []; onSave(data); }}>Сохранить</NewButton>
    </div>
  );

  return (
    <React.Fragment>
      <Dialog
        footer={footer}
        focusOnShow={false}
        contentStyle={{ overflow: `visible` }}
        className="pd-dialog"
        header={(folder?.Id ?? 0) > 0 ? "Изменение тома" : "Добавление тома"}
        visible={visible}
        onHide={onCancel}>
        <div className="pd-dialog-body">
          <div className="pd-dialog-field">
            <span className="pd-dialog-label">Название</span>
            <NewInput
              type="text"
              className="w-100"
              placeholder="Введите название"
              value={data.Title}
              onChange={(e) => setData({ ...data, Title: e.currentTarget.value })} />
            {!data.Title && <small className="pd-field-error">Укажите значение</small>}
          </div>
          {hasCypher() && (
            <div className="pd-dialog-field">
              <span className="pd-dialog-label">Шифр</span>
              <NewInput
                type="text"
                className="w-100"
                placeholder="Введите шифр"
                value={data.Cypher}
                onChange={(e) => setData({ ...data, Cypher: e.currentTarget.value })} />
              {!data.Cypher && <small className="pd-field-error">Укажите значение</small>}
            </div>
          )}
          {hasDocumentDate() && (
            <div className="pd-dialog-field">
              <span className="pd-dialog-label">Дата документа</span>
              <NewCalendar
                keepInViewport
                appendTo={document.body}
                locale="ru"
                dateFormat={constantFormat.calendar}
                className="w-100"
                value={constantFormat.StringToDate(data.DocumentDate as string)}
                onChange={(e) => setData({ ...data, DocumentDate: e.value as Date })} />
              {!data.DocumentDate && <small className="pd-field-error">Укажите значение</small>}
            </div>
          )}
        </div>
      </Dialog>
    </React.Fragment>
  );
}
